var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 54,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3878_3491",
    transform: "translate(0.00909091) scale(0.0109091 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3878_3491",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAADvUlEQVR4nO2cTWxMURTHf6Ol2qQNGm1IhbY2jZ1vIkEIsZJgJ7HCggUbEbGxYyPBzgYrsfTVBa2EpIlV01ZQ3ZRGfQWJDaX6YfGmSdt0Xt+Yd//3zvT8krObvHPPb+7Me/e+8x4YhmEYhmEYhmEESsb3AGJoBrYDW4DVQBNQnY0/wDfgLfAMuAd0+RlmcVIFnAQ6gfE8ox1Yox9ycZEBjgJfyV/w5BgCDovHXjTUAo8oTPDkGAX2SytIQJnn/A1AB7AhxWNmgN1E/+N1wA/gZ4rHLzoWA29Ibybnit/ALWC5pqywyACtuJc8OT4AGxXFhcQRtJIn4juwUlBfEFQAg/gRPQ48dV9iGBzDn+SJ2OO8ygB4jn/Rbc6r9Ew9/iWPA3+BJY5rncI8ZTKifYsQKAf2KROqRW8T54tjvTKZWvRacb44pBtQatFLxfniaFYmU4uWnoBmoUaZbC6LrlYmU4seEeeLY1iZTC36ozhfHJ+UydSi34nzxTGoTKYW3SHOF4d0LGrRj8X54njiewCu6cX/Xkc/4kmmntEQxs5ZKzDmexAu2UF0l9r3jB4las4pWe7jX/JE3HVc6xTUfx1N4nxxNCqTqUWH1F8xpEymFt0jzheHtClSLfqhOF8crb4H4JIy4AX+T4Q9+Lm0ldIIdONPchewynmVAXENveSrkspmwOfPp91DzhBWpXIWAF/QzebPwHxJZTPgc0YPAxeF+S4TNc7MScqBl7ifzf1ApaimYNmJ242mUWCXrJrAOY870eeEdQRPBrhD+pJvE/azlF4oI7rOTUvydTxeZUwnxG97PKXjBFVbya/3Q8FEizDRIky0CBMtIjTRaa7gbDWYgyr+7z0duaIze0xjEjVE+9NprwzbEDech0oGOITbR5bfAwcJbAGjog44gbbh8XU2Z52gPq80AMeBB0Qb8CrB02OUqDf6LOIns1zSBJwiKmwMf3Lj4hVwAVjnyIEzWoBLQB/+JeYbfdmxt6RuJSUywAGimetbVlrRka0pmJPoXqLOH99iXEV3tkZvLAJu4l+EKm5ka5ayjDB66NTRC6xIwV8imoABxwWFHAMIGuorSHc/olijB1hYoMtYfDQmhhpXCnSZk0b8ruhCixHyWFnmsx99hqiFy4goA04n/XDSi/Eqohdjz/n+tWkMEb0teNYHj5LO6K2Y5JmoJOGbz5KKLumnTAskkZukojcVMJBSZ3OSDyUVXV/AQEqdRDcSkoquLWAgpU4iN0mvOn5hJ8NcDGF32w3DMAzDMAzDKGb+AVbyTqoCCI6aAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBooking);
export default __webpack_public_path__ + "static/media/single-booking.b2a80e870322c585d7ef8b8f782188d7.svg";
export { ForwardRef as ReactComponent };